import React from 'react';
import DropDownFilterChipLayout from 'src/components/10-atoms/filters/DropdownFilterChip';
import SelectInputDrawer from 'src/components/10-atoms/form/inputs/SelectInput/SelectInputDrawer';
import { ISelectionType } from 'src/components/10-atoms/form/inputs/SelectInput/types';
import Typography from 'src/components/10-atoms/typography/Typography';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
const options = [{
        id: undefined,
        title: 'All Questions'
    }, {
        id: true,
        title: 'Answered'
    }, {
        id: false,
        title: 'Unanswered'
    }];
const AnsweredFilter = ({ value, onChange }) => {
    const [{}] = useTheme(stylesGenerator);
    const selectedOption = options.find(option => option.id === value);
    const label = selectedOption?.title ?? options[0].title;
    const showOptions = useStableCallback(() => {
        bottomDrawerHelperActions.show({
            component: (React.createElement(SelectInputDrawer, { title: 'Select Answered filter', type: ISelectionType.SINGLE, value: selectedOption, options: options, onChange: option => {
                    bottomDrawerHelperActions.hide();
                    onChange(option.id);
                }, onCancel: bottomDrawerHelperActions.hide }))
        });
    });
    return (React.createElement(DropDownFilterChipLayout, { selected: selectedOption?.id !== undefined, onPress: showOptions },
        React.createElement(Typography, null, label)));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default AnsweredFilter;
